<template>
<div class="">



  <div class="row" >   
    <div class="col s12 m8 offset-m2 yo-align-center ">
      <a href="https://www.sip.it"><img src="../assets/logo.png" style="width:100%;max-width:400px;"/> </a>
      <h2>Diventa socio SIP</h2>
    </div>
    
  </div>



<div class="title_h1 yo-color-primary" style="margin-top:30px;">RICHIESTA DI ISCRIZIONE</div>
<br />
Il sottoscritto, presa visione delle norme statutarie della Società Italiana di Pediatria, che si impegna a rispettare e a far rispettare, CHIEDE di essere ammesso quale socio ordinario.
<div class="title_h1 yo-color-primary" style="margin-top:30px;">QUOTA DI ISCRIZIONE:</div>
La quota sociale è di Euro 100.00

<!--

<ul>
<li>Euro 90.00 Socio ordinario</li>
  <li>CCP sul c/c num. 67412643 intestato a SOCIETÀ ITALIANA DI PEDIATRIA
<div class="crimson">(pagabile anche online tramite il servizio offerto dalla propria banca con l'addebito diretto sul suo conto corrente)</div>

</li>
<li>CAUSALE: Nuova iscrizione SIP</li>
</ul>
-->

   <el-form ref="formBasic" v-if="typeof $socio.contatto.row.id != 'undefined'" :model="$socio.contatto.row" @submit.native.prevent="onSubmit" :rules="rules" label-width="180px" style="margin-top:20px;">

   <div class="title_h1 yo-color-primary" style="margin-top:30px;">DATI ANAGRAFICI</div>

   <div class="row pad" style="margin-top:20px;">
          
      <div class="col s12 m6">
      <el-form-item label="Cognome" prop="cognome">
        <el-input  v-model="$socio.contatto.row.cognome"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Nome" prop="nome">
        <el-input  v-model="$socio.contatto.row.nome"></el-input>
      </el-form-item>
      </div> 


      <div class="col s12 m6">
      <el-form-item label="Email" prop="email">
        <el-input  v-model="$socio.contatto.row.email"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Reinserisci Email" prop="emailcheck"  class="is-required">
        <el-input  v-model="emailcheck"></el-input>
      </el-form-item>
      </div> 


      <div class="col s12 m6 clear">
      <el-form-item label="Data di nascita" prop="datanascita" class="is-required">
        <el-date-picker v-model="$socio.contatto.row.datanascita" type="date" placeholder="Indica la tua data nel formato gg-mm-aaaa" style="width:100%;" format="dd-MM-yyyy" value-format="yyyy-MM-dd" ></el-date-picker>
      </el-form-item>
      </div> 


      <div class="col s12 m6">
      <el-form-item label="Sesso" prop="sesso">
        <el-select v-model="$socio.contatto.row.sesso"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="Maschio" value="M" ></el-option>
          <el-option label="Femmina" value="F" ></el-option>
        </el-select>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Nazione di nascita" prop="natonazione">
        <el-select v-model="$socio.contatto.row.natonazione"  filterable placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._nazione" :key="item.id" :label="item.nome" :value="item.iso3" ></el-option>
        </el-select>
      </el-form-item>
      </div>
   

      <div class="col s12 m6" v-if="$socio.contatto.row.natonazione=='ITA'">
      <el-form-item label="Provincia di nascita" prop="natoprovincia">
        <el-select v-model="$socio.contatto.row.natoprovincia" filterable placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._provincia" :key="item.sigla" :label="item.nome" :value="item.sigla" ></el-option>
        </el-select>
      </el-form-item>
      </div>

      <div class="col s12 m6" v-if="$socio.contatto.row.natonazione=='ITA'">
      <el-form-item label="Città di nascita" prop="luogonascita">
        <el-select v-model="$socio.contatto.row.luogonascita" filterable placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._comune" v-if="item.provincia==$socio.contatto.row.natoprovincia" :key="item.id" :label="item.nome" :value="item.nome" ></el-option>
        </el-select>
      </el-form-item>
      </div>

      
      <div class="col s12" v-if="$socio.contatto.row.natonazione!='ITA'">
      <el-form-item label="Città di nascita" prop="luogonascita">
        <el-input  v-model="$socio.contatto.row.luogonascita"></el-input>
      </el-form-item>
      </div>


      <div class="col s12 m6">
      <el-form-item label="Codice Fiscale" prop="cf">
        <el-input  v-model="$socio.contatto.row.cf"></el-input>
      </el-form-item>
      </div>

      <div class="col s12">
      <el-form-item label="Domicilio" prop="indirizzo">
        <el-input  v-model="$socio.contatto.row.indirizzo"></el-input>
      </el-form-item>
      </div>

      <div class="col s12 m6">
      <el-form-item label="CAP" prop="cap">
        <el-input  v-model="$socio.contatto.row.cap"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Provincia" prop="pr">
        <el-select v-model="$socio.contatto.row.pr"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._provincia" :key="item.id" :label="item.nome" :value="item.sigla" ></el-option>
        </el-select>
      </el-form-item>
      </div> 

      <div class="col s12">
      <el-form-item label="Città" prop="citta">
        <el-input  v-model="$socio.contatto.row.citta"></el-input>
      </el-form-item>
      </div> 



      <div class="col s12 m6">
      <el-form-item label="Cellulare" prop="cell">
        <el-input  v-model="$socio.contatto.row.cell"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Telefono Casa" prop="telcasa">
        <el-input  v-model="$socio.contatto.row.telcasa"></el-input>
      </el-form-item>
      </div> 

    </div>

    <div class="title_h1 yo-color-primary" style="margin-top:30px;">DATI LAVORO</div>

    <div class="row pad" style="margin-top:20px;">

      <div class="col s12">
      <el-form-item label="Struttura/Ente" prop="ente">
        <el-input  v-model="$socio.contatto.row.ente"></el-input>
      </el-form-item>
      </div>

      <div class="col s12">
      <el-form-item label="Unità Operativa" prop="uonome">
        <el-input  v-model="$socio.contatto.row.uonome"></el-input>
      </el-form-item>
      </div>


      <div class="col s12">
      <el-form-item label="Indirizzo" prop="uoindirizzo">
        <el-input  v-model="$socio.contatto.row.uoindirizzo"></el-input>
      </el-form-item>
      </div>

      <div class="col s12 m6">
      <el-form-item label="CAP" prop="uocap">
        <el-input  v-model="$socio.contatto.row.uocap"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Provincia" >
        <el-select v-model="$socio.contatto.row.uopr"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option v-for="item in $teras._provincia" :key="item.id" :label="item.nome" :value="item.sigla" ></el-option>
        </el-select>
      </el-form-item>
      </div> 

      <div class="col s12">
      <el-form-item label="Città" prop="uocitta">
        <el-input  v-model="$socio.contatto.row.uocitta"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="FAX" prop="uofax">
        <el-input  v-model="$socio.contatto.row.uofax"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Telefono Lavoro" prop="uotel">
        <el-input  v-model="$socio.contatto.row.uotel"></el-input>
      </el-form-item>
      </div> 


    </div>

    <div class="title_h1 yo-color-primary" style="margin-top:30px;">ISTRUZIONE</div>

    <div class="row pad" style="margin-top:20px;">

      <div class="col s12 m6">
      <el-form-item label="Qualifica"  prop="tipocat">
        <el-select v-model="$socio.contatto.row.tipocat"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="Medico chirurgo" value="14" ></el-option>
          <el-option label="Medico med. generale (medico di famiglia)" value="36" ></el-option>
          <el-option label="Pediatra di libera scelta" value="37" ></el-option>
          <el-option label="Altro" value="1" ></el-option>
        </el-select>
      </el-form-item>
      </div>
      
      <div class="col s12 m6">
      <el-form-item label="Anno di laurea" prop="annolaurea" >
        <el-date-picker v-model="$socio.contatto.row.annolaurea" type="year" placeholder="Scegli un anno" style="width:100%;" format="yyyy" value-format="yyyy"></el-date-picker>
      </el-form-item>
      </div>
<!--
      <div class="col s12">
      <el-form-item label="Specializzazioni" prop="specializzazioni">
        <el-input  v-model="$socio.contatto.row.specializzazioni"></el-input>
      </el-form-item>
      </div>
-->

       

      <div class="col s12">
      <el-form-item label="Ruolo" prop="ruolo">
        <el-select v-model="$socio.contatto.row.ruolo"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="ospedaliero" value="19" ></el-option>
          <el-option label="ospedaliero - borsista" value="18" ></el-option>
          <el-option label="ospedaliero - direttore di u.o. complessa" value="2" ></el-option>
          <el-option label="ospedaliero - direttore di u.o. semplice" value="3" ></el-option>
          <el-option label="ospedaliero - dirigente" value="7" ></el-option>
          <el-option label="ospedaliero - infermiere" value="22" ></el-option>
          <el-option label="ospedaliero - pensionato" value="14" ></el-option>
          <el-option label="ospedaliero - ricercatore" value="17" ></el-option>
          <el-option label="ospedaliero - specializzando" value="16" ></el-option>
          <el-option label="universitario" value="20" ></el-option>
          <el-option label="universitario - borsista" value="13" ></el-option>
          <el-option label="universitario - pensionato" value="15" ></el-option>
          <el-option label="universitario - professore associato" value="9" ></el-option>
          <el-option label="universitario - professore ordinario" value="10" ></el-option>
          <el-option label="universitario - ricercatore" value="11" ></el-option>
          <el-option label="universitario - specializzando" value="12" ></el-option>
          <el-option label="pediatra di libera scelta" value="21" ></el-option>
          <el-option label="medico emergenza territoriale" value="25" ></el-option>
          <el-option label="libero professionista" value="23" ></el-option>
          <el-option label="volontario" value="24" ></el-option>
          <el-option label="altro" value="26" ></el-option>
        </el-select>
      </el-form-item>
      </div> 

      <div class="col s12 m6 clear">
        <div class="col s4"><label for="allegato" class="el-form-item__label" style="width:100% !important">Curriculum Vitae</label></div>
        <upload class="col s8" 
        :value="$socio.contatto.row.cvitae" 
        v-on:change="val => $socio.contatto.row.cvitae=val" 
        v-on:success="cvitaeSuccess" 
        action="https://api.terasmm.it/201806/vue/upload/" 
        :savedir="'members.sip.it/upload/cvitae/'" 
        :previewurl="'https://members.sip.it/upload/cvitae/'" 
        extensions="pdf,doc,docx"></upload>
      </div>

    </div>


    <div class="title_h1 yo-color-primary" style="margin-top:30px;">DATI SIP</div>

    <div class="row pad" style="margin-top:20px;">

      <div class="col s12">
      <el-form-item label="Cariche SIP ricoperte in passato" prop="sip_carichepassato">
        <el-input  v-model="$socio.contatto.row.sip_carichepassato"></el-input>
      </el-form-item>
      </div>

      <div class="col s12">
      <el-form-item label="Socio di Soc. Affiliata alla SIP" prop="sip_socioaffiliate">
        <el-input  v-model="$socio.contatto.row.sip_socioaffiliate"></el-input>
      </el-form-item>
      </div>

      <div class="col s12">
      <el-form-item label="Socio di altra Soc. Scientifica" prop="sip_socioaltro">
        <el-input  v-model="$socio.contatto.row.sip_socioaltro"></el-input>
      </el-form-item>
      </div>

      <div class="col s12" v-if="$socio.contatto.row.ruolo==12 || $socio.contatto.row.ruolo==16">
      <el-form-item label="Vuole attivare la polizza RC Professionale" prop="sip_rcspecializzando">
        <el-select v-model="$socio.contatto.row.sip_rcspecializzando"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="Si" value="1" ></el-option>
          <el-option label="No" value="0" ></el-option>
        </el-select>
      </el-form-item>
      </div>

    </div>





    <div class="title_h1 yo-color-primary" style="margin-top:30px;">SOCI PRESENTATORI</div>

    
    <div class="row pad" style="margin-top:20px;">

      <div style="col s12">I soci presentatori devono essere regolarmente iscritti alla Società Italiana di Pediatria da almeno 5 anni.
      <br />
      Indicare il nome e cognome dei 2 soci nei box qui sotto
      <br /><br />
      </div>


      <div class="col s12 m6">
      <el-form-item label="Nominativo Socio 1" prop="socio1">
        <el-input  v-model="$socio.contatto.row.socio1"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Nominativo Socio 2" prop="socio2">
        <el-input  v-model="$socio.contatto.row.socio2"></el-input>
      </el-form-item>
      </div> 

    </div>




    




    <div class="title_h1 yo-color-primary" style="margin-top:30px;">INFORMATIVA PRIVACY AI SENSI DELL’ ART. 13 DEL REGOLAMENTO EU n. 679/2016</div>
    
    <div class="row pad" style="margin-top:20px;">

    <div class="col s2 yo-align-right clear"> <el-form-item label="" class="no-label" prop="authbasic">
          <el-checkbox v-model="$socio.contatto.row.authbasic" :true-label="authcheck" false-label="" disabled></el-checkbox>
          </el-form-item>
        </div>
        <div class="col s10" style="padding-bottom:20px;padding-top:10px;">
          Si chiede di prendere visione dell' <a :href="'https://members.sip.it/privacy-SIP.pdf?'+$teras.random()" target="_blank" style="color:red;font-weight:bold;">informativa privacy</a> dei Soci della Società Italiana di Pediatria. 
        </div>

        <div class="col s12 m10 offset-m2">
        Si prega di prestare eventuale consenso facoltativo:
        </div>
        
        <div class="col s2 yo-align-right clear"> <el-form-item label="" class="no-label" prop="authcommercial">
          <el-checkbox v-model="$socio.contatto.row.authcommercial" :true-label="authcheck" false-label=""></el-checkbox>
          </el-form-item>
        </div>
        <div class="col s10" style="padding-bottom:20px;padding-top:10px;">
          Per il trattamento dei dati personali al fine di un eventuale invio di materiale informativo da parte di altre associazioni e/o altri soggetti giuridici aventi interessi comuni con la Società Italiana di Pediatria.
        </div>


    </div>

    <div class="title_h1 yo-color-primary " style="margin-top:30px;">LIBERATORIA E AUTORIZZAZIONE ALLA RIPRODUZIONE DI MATERIALE CARTACEO E FOTOGRAFICO</div>
    
    <div class="row" style="margin-top:20px;">

      <div class="col s12">
        Dichiaro di aver preso visione della <a :href="'https://members.sip.it/liberatoria-SIP.pdf?'+$teras.random()" target="_blank" class="ui-link">Liberatoria</a>  e autorizzo la Titolare Società Italiana di Pediatria al trattamento dei dati personali in relazione alla riproduzione di materiale cartaceo e fotografico. 
      </div>

      <div class="col s12">
      <el-form-item label="">
        <div class="row pad">
        <div class="col s5" style="width:50px;">
        <el-switch v-model="$socio.contatto.row.authmaterial" inactive-value="0" :active-value="authcheck"></el-switch>
        </div>
        <div class="col s10 crimson" v-if="$socio.contatto.row.authmaterial=='0'">Non autorizzo </div>
        <div class="col s10" v-if="$socio.contatto.row.authmaterial==authcheck">Autorizzo</div>
        </div>
      </el-form-item>
      </div> 
  
    </div>





    <div class="row pad" style="margin-top:20px;">
      <div class="col s6 m4 offset-m1">
          <el-button style="width:100%;margin:10px 0;"  @click="onCancel">Non ora</el-button>
      </div>
        
      <div class="col s6 m4 offset-m1">
          <el-button type="primary" @click="onSubmit" style="width:100%;background-color:#002f6d;border:none;margin:10px 0;">Registrati</el-button>
      </div>
    </div>


    </el-form>



</div>
</template>

<script>
import upload from './Yo-upload.vue'
export default {
  name: 'socio-edit',
  components: {
    upload
  },
  data() {
    return {
      itm: this.$socio.contatto.row, //mi serve per far si che funzioni correttamente il binding
      emailcheck:'',
      authcheck: this.$moment().format('YYYY-MM-DD'),
      checkEmail: function (rule, value, callback)  {
       console.log(this.emailcheck)
       if(typeof value !='undefined')
        if (value.toString()!=this.$socio.contatto.email) {
          return callback(new Error('L\'indirizzo email di controllo non corrispondende all\'indirizzo email!'));
        }else{
          callback();
        }
      }
    }
  },
  created () {
    console.log("Arrivo al socio-edit.vue")
    this.$teras.pageTitle = (this.$socio.contatto.row.id=='') ? 'Nuova Attività' : 'Modifica Attività: '+this.$socio.contatto.row.id

    this.$socio.contatto.row.authbasic = this.authcheck
    console.log(this.$socio.contatto.row)
  },
  beforeDestroy () {
    clearInterval(this.minInterval)
  },
  methods: {
    cvitaeSuccess() {
      //this.doUpdate()
      this.$notify.success({type: 'info',message: 'Curriculum Vitae allegato correttamente', duration:5000})    
        
    },
    onCancel() {
        //this.$router.go(-1)
        this.$router.push('/socio-noregister/')
    },
    onSubmit() {
      this.$refs.formBasic.validate(async (valid) => {
        if (valid) {
          console.log(this.$socio.contatto.row)

          if(this.$socio.contatto.row.email != this.emailcheck){
            this.$notify.error({
              title: 'Errore',
              message: 'L\'indirizzo email di controllo non corrispondende all\'indirizzo email!'
            });
          }else if(this.$socio.contatto.row.authbasic != this.authcheck){
            console.log(this.$socio.contatto.row.authbasic)
            this.$notify.error({
              title: 'Errore',
              message: 'Bisogna accettare la privacy!'
            });
          /*eliminato fino al 27 maggio 2021
          }else if(this.$socio.contatto.row.cvitae.length < 5){
            console.log(this.$socio.contatto.row.cvitae)
            this.$notify.error({
              title: 'Errore',
              message: 'Bisogna allegare il proprio curriculum vitae!'
            });*/
          }else if(this.$socio.contatto.row.natodata=='' || parseInt(this.$moment(this.$socio.contatto.row.natodata).toNow('yy',true))<18)  {
            this.$notify.error({
              title: 'Errore',
              message: 'Bisogna essere maggiorenni!'
            });
          }else{
            let error = 0
            let checkEmail = await this.$socio.checkEmail(this.$socio.contatto.row.email)
            if(checkEmail==false)
              error = 101
            
            let checkEmailLimmsy = await this.$socio.checkEmailLimmsy(this.$socio.contatto.row.email)
            if(checkEmailLimmsy==false)
              error = 102

            let checkCodicefiscale = await this.$socio.checkCodicefiscale(this.$socio.contatto.row.cf)
            if(checkCodicefiscale==false)
              error = 201

            let checkCodicefiscaleLimmsy = await this.$socio.checkCodicefiscaleLimmsy(this.$socio.contatto.row.cf)
            if(checkCodicefiscaleLimmsy==false)
              error = 202

            
            if(error==0){
              this.Save()
            }else{
              this.$notify.error({
              title: 'Errore '+error,
              message: 'Lei sembra già essere tra i nostri soci o ha già provato ad iscriversi, la preghiamo di contattare la segreteria!'
              })

            }

            
            /*.then((data) => {
              if(data){
                this.Save()
              }else{
                parent;
              }
            })
            */
          }
        } else {
          return false;
        }
      });
    },
    Save(){
      //this.$socio.contatto.row.utente = this.$teras.utente.id
      //if( !moment(this.$socio.contatto.row.inseritoil).isValid())
        //this.$socio.contatto.row.inseritoil = moment().format('YYYY-MM-DD HH:mm:00')


      this.$socio.contatto.row.cognome = this.$socio.contatto.row.cognome.toUpperCase()
      this.$socio.contatto.row.nome = this.$socio.contatto.row.nome.toUpperCase()
      this.$socio.contatto.row.inseritoil = this.$moment().format('YYYY-MM-DD HH:mm:00')
      this.$socio.contatto.row.step = 1

      this.$socio.contatto.row.browsername = this.$teras.browser.name+' » '+this.$teras.browser.version+' » '+this.$teras.browser.os

      
      this.$socio.contatto.save().then(data => {
        this.$storage.save("utente",this.$socio.contatto.row.id)
        this.$axios.get('https://members.sip.it/sip/schedaesternasolopdf/id/'+this.$socio.contatto.row.id)
        this.$router.push('/socio-pagamento/')
      })
      
      
    }

  },
  computed: {
    rules:function() {
      var rulesNow = {
        cognome: [
          { required: true, message: 'Il cognome è obbligatorio', trigger: 'blur'  }
        ],
        nome: [
          { required: true, message: 'Il nome è obbligatorio', trigger: 'blur' }
        ],
        cf: [
          { required: true, message: 'Il codice fiscale è obbligatorio', trigger: 'blur' }
        ], 
        sesso: [
          { required: true, message: 'Il sesso è obbligatorio'}
        ],
        indirizzo: [
          { required: true, message: 'L\'indirizzo di residenza è obbligatorio', trigger: 'blur' }
        ],
        cap: [
          { required: true, message: 'Il cap di residenza è obbligatorio', trigger: 'blur' }
        ],
        pr: [
          { required: true, message: 'La provincia di residenza è obbligatoria', trigger: 'blur' }
        ],
        citta: [
          { required: true, message: 'La città di residenza è obbligatoria', trigger: 'blur' }
        ],
        ruolo: [
          { required: true, message: 'La specializzazione è obbligatoria', trigger: 'blur' }
        ],
        ente: [
          { required: true, message: 'Il proprio ente è obbligatorio', trigger: 'blur' }
        ],
        uonome: [
          { required: true, message: 'La propria unità operativa è obbligatorio', trigger: 'blur' }
        ],
        uoindirizzo: [
          { required: true, message: 'L\'indirizzo di lavoro è obbligatorio', trigger: 'blur' }
        ],
        uocap: [
          { required: true, message: 'Il cap di lavoro è obbligatorio', trigger: 'blur' }
        ],
        uopr: [
          { required: true, message: 'La provincia di lavoro è obbligatoria', trigger: 'blur' }
        ],
        uocitta: [
          { required: true, message: 'La città di lavoro è obbligatoria', trigger: 'blur' }
        ]
        
        
        
        
        /*,
        statocivile: [
          { required: true, message: 'Il tuo stato civile è obbligatorio'}
        ],
        emailchecks: [
          { required: true, message: 'L\'indirizzo email di controllo è obbligatorio'}
        ],     
        email: [
          { required: true, message: 'L\'indirizzo email è obbligatorio'},
          { type: 'email', message: 'Inserire un indirizzo email corretto', trigger: 'blur,change' }
        ],
        socio1: [
          { required: true, message: 'Il nominativo del primo socio è obbligatorio' }
        ],
        socio2: [
          { required: true, message: 'Il nominativo del secondo è obbligatorio'}
        ],  
        cf: [
          { required: true, message: 'Il codice fiscale è obbligatorio'}
        ]
        luogonascita: [
          { required: true, message: 'La città di nascita è obbligatoria' , trigger: 'blur' }
        ],
        natonazione: [
          { required: true, message: 'La nazione di nascita è obbligatoria' }
        ],
        natoprovincia: [
          { required: this.$socio.contatto.row.natonazione=='ITA', message: 'La provincia di nascita è obbligatoria' }
        ],
        tipocat: [
          { required: true, message: 'La qualifica è obbligatoria', trigger: 'blur' }
        ],
        annolaurea: [
          { required: true, message: 'L\'anno di laurea è obbligatorio', trigger: 'blur' }
        ]
        */
      }
      return rulesNow
    }
  }
}
</script>
<style>
/*
.el-checkbox {
    width: 100%;
    margin: 0 !important;
}.el-form-item__label{
  width: 16.66% !important;
}.el-form-item__content{
  margin-left: 16.66% !important;

}.col.m6 .el-form-item__label{
  width: 33.32% !important;
}.col.m6 .el-form-item__content{
  margin-left: 33.32% !important;


}.col.m4 .el-form-item__label{
  width: 50% !important;
 */ 
.el-switch.is-checked .el-switch__core{
  background-color:#002f6d;
  border-color:#002f6d;


}.el-upload{
  display:block !important;
}.el-upload-dragger{
  height:100px !important;
  width:100% !important;
}
</style>